import React from 'react';
import useFullscreen from './useFullscreen';
import FullscreenButton from './FullscreenButton';
import FullscreenContainer from './FullscreenContainer';

/**
 * Complete fullscreen wrapper component that combines hook, button, and container
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 * @param {Object} props.containerProps - Props to pass to FullscreenContainer
 * @param {Object} props.buttonProps - Props to pass to FullscreenButton
 * @param {boolean} props.showButton - Whether to show the fullscreen button
 * @param {Function} props.onFullscreenChange - Callback when fullscreen state changes
 */
const FullscreenWrapper = ({ 
  children, 
  containerProps = {},
  buttonProps = {},
  showButton = true,
  onFullscreenChange
}) => {
  const { 
    isFullscreen, 
    isFullscreenSupported, 
    toggleFullscreen, 
    elementRef 
  } = useFullscreen();

  // Call the callback when fullscreen state changes
  React.useEffect(() => {
    if (onFullscreenChange) {
      onFullscreenChange(isFullscreen);
    }
  }, [isFullscreen, onFullscreenChange]);

  return (
    <FullscreenContainer
      isFullscreen={isFullscreen}
      containerRef={elementRef}
      {...containerProps}
    >
      {/* Fullscreen Button */}
      {showButton && isFullscreenSupported && (
        <FullscreenButton
          isFullscreen={isFullscreen}
          onToggle={toggleFullscreen}
          {...buttonProps}
        />
      )}
      
      {children}
    </FullscreenContainer>
  );
};

export default FullscreenWrapper; 